import { DOT_COLORS, LOANREQUEST_BUCKETS } from 'cpool-constants';
import type {
    SchemaLoanRequestResolver_Get,
    SchemaLoanRequestResolver_GetSummary,
} from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import {
    LuFileX,
    LuFilterX,
    LuHandCoins,
    LuPackageCheck,
    LuShoppingCart,
    LuTriangleAlert,
    LuUsersRound,
} from 'react-icons/lu';
import { PiCrane } from 'react-icons/pi';

import type { LeadTraitInfo } from '~/types/LeadTraits';

export const getBucketInfo = (
    lead: SchemaLoanRequestResolver_GetSummary[number] | SchemaLoanRequestResolver_Get,
    t: TFunction<'de' | 'en', undefined>,
): LeadTraitInfo => {
    if (!lead.type) return null;
    switch (lead.type) {
        case LOANREQUEST_BUCKETS.BAUFI:
            return {
                dot: DOT_COLORS.GREEN,
                Icon: PiCrane,
                text: t('LEADS.TRAIT.TYPE.BAUFI'),
            };
        case LOANREQUEST_BUCKETS.IK:
            return {
                dot: DOT_COLORS.GREEN,
                Icon: LuHandCoins,
                text: t('LEADS.TRAIT.TYPE.IK'),
            };
        case LOANREQUEST_BUCKETS.IK_CLEARING:
            return {
                dot: DOT_COLORS.GREEN,
                Icon: LuHandCoins,
                text: t('LEADS.TRAIT.TYPE.IK_CLEARING'),
            };
        case LOANREQUEST_BUCKETS.PARTNER_SERVICE:
            return {
                dot: DOT_COLORS.GREEN,
                Icon: PiCrane,
                text: t('LEADS.TRAIT.TYPE.PARTNER_SERVICE'),
            };
        case LOANREQUEST_BUCKETS.PK:
            return {
                dot: DOT_COLORS.GREEN,
                Icon: LuShoppingCart,
                text: t('LEADS.TRAIT.TYPE.PK'),
            };
        case LOANREQUEST_BUCKETS.PROCHECK:
            return {
                dot: DOT_COLORS.GREEN,
                Icon: LuPackageCheck,
                text: t('LEADS.TRAIT.TYPE.PROCHECK'),
            };
        case LOANREQUEST_BUCKETS.INCOMPLETE:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuTriangleAlert,
                text: t('LEADS.TRAIT.TYPE.INCOMPLETE'),
            };
        case LOANREQUEST_BUCKETS.SELF_EMPLOYED:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuTriangleAlert,
                text: t('LEADS.TRAIT.TYPE.SELF_EMPLOYED'),
            };
        case LOANREQUEST_BUCKETS.NOT_FINANCEABLE:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuTriangleAlert,
                text: t('LEADS.TRAIT.TYPE.NOT_FINANCEABLE'),
            };
        case LOANREQUEST_BUCKETS.JOB_STATUS:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuTriangleAlert,
                text: t('LEADS.TRAIT.TYPE.JOB_STATUS'),
            };
        case LOANREQUEST_BUCKETS.SCHUFA_ERROR:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuFileX,
                text: t('LEADS.TRAIT.TYPE.SCHUFA_ERROR'),
            };
        case LOANREQUEST_BUCKETS.SCHUFA_NEGATIVE:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuFileX,
                text: t('LEADS.TRAIT.TYPE.SCHUFA_NEGATIVE'),
            };
        case LOANREQUEST_BUCKETS.SCHUFA_SCORE:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuFilterX,
                text: t('LEADS.TRAIT.TYPE.SCHUFA_SCORE'),
            };
        case LOANREQUEST_BUCKETS.POTENTIAL_LEAD:
            return {
                dot: DOT_COLORS.YELLOW,
                Icon: LuUsersRound,
                text: t('LEADS.TRAIT.TYPE.POTENTIAL_LEAD'),
            };
        default:
            return null;
    }
};
